import I3IntervalType = ToroEnums.I3IntervalType;
import I3TaskStatus = ToroEnums.I3TaskStatus;
import I3TaskSubType = ToroEnums.I3TaskSubType;
import I3TaskType = ToroEnums.I3TaskType;

import * as moment from 'moment';
import { ToroEnums } from '../../../common/enumerations/toro.enums';

export class I3AssetsMaintenanceDue {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.maintenanceDueAssetListModel) { this.maintenanceDueAssetListModel = json.maintenanceDueAssetListModel.map(a => new I3MaintenanceDueTask(a)); }

        }
    }

    maintenanceDueAssetListModel: I3MaintenanceDueTask[] = [];
}

export class I3MaintenanceDueTask {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.nextDueInDate) this.nextDueInDate = moment.utc(json.nextDueInDate).toDate();
        }
    }

    assetMaintenanceTaskId: number;
    assetId: number;
    assetName: string;
    description: string;
    nextDueInDate: Date;
    nextDueInMeter: number;
    nextDueUnit: string;
    interval: number;
    intervalTypeId: I3IntervalType;
    workOrderId: number;
    partsOnHand: number;
    partsToOrder: number;
    taskStatus: I3TaskStatus;
    taskTypeId: I3TaskType;
    taskSubTypeId: I3TaskSubType;
    taskTypeName: string;
    taskSubTypeName: string;

    get taskTypeString() {
        switch (this.taskTypeId) {
            case I3TaskType.Preventive:
                return 'STRINGS.PREVENTIVE';
            case ToroEnums.I3TaskType.Repair:
                return 'STRINGS.REPAIR';
            case ToroEnums.I3TaskType.General:
                return 'STRINGS.GENERAL';
            default:
                return 'STRINGS.UNKNOWN';

        }
    }
}

export class I3MaintenanceDueAsset {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.tasks) this.tasks =  json.tasks.map(t => new I3MaintenanceDueTask(t));
        }
    }

    assetId: number;
    tasks: I3MaintenanceDueTask[] = [];
}



